var _rect, _rect2, _path, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyViewFavorite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 0.874512,
    y: 7.4668,
    width: 36.3586,
    height: 43.8934,
    rx: 7.17603,
    fill: "#C5D2DF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 3.19873,
    y: 5.2627,
    width: 36.3586,
    height: 43.8934,
    rx: 7.17603,
    fill: "#E5EAEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.0159 29.0625L49.1255 32.1721",
    stroke: "#B1C3D6",
    strokeWidth: 4.78402,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 15.3656,
    y: -1.22835,
    width: 33.0744,
    height: 33.0749
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(0.61px)",
      clipPath: "url(#bgblur_0_21779_11612_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 1.22835,
    cx: 31.9029,
    cy: 15.3089,
    r: 13.5747,
    fill: "white",
    fillOpacity: 0.4,
    stroke: "#B1C3D6",
    strokeWidth: 3.46842
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_21779_11612_clip_path"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "translate(-15.3656 1.22835)",
    cx: 31.9029,
    cy: 15.3089,
    r: 13.5747
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyViewFavorite);
export default __webpack_public_path__ + "static/media/empty-view-favorite.6ac415fec9364601128f0f9d98e553c9.svg";
export { ForwardRef as ReactComponent };